import { SITE_LINKS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Button } from "../ui/Button";

import styles from "./CtaBanner.module.css";

export function CtaBanner() {
  const { copy } = useLocale();

  return (
    <section className={styles.banner}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{copy.ctaBanner.title}</h2>
        <div className={styles.actions}>
          <Button href={SITE_LINKS.download}>{copy.cta.download}</Button>
          <Button href={SITE_LINKS.pricing} variant="secondary">
            {copy.cta.buyLicense}
          </Button>
        </div>
      </div>
    </section>
  );
}
